<template>
  <div>
    <div class="deposit-title mt-5 mt-md-1">
      <p>Выберите способ пополнения</p>
    </div>
    <div class="row mt-2" v-if="depositMethods">
      <div class="col-12 col-lg-12 p-md-X">
        <div>
          <div class="row">
            <div class="col-6 col-md-4 col-lg-3 px-2 px-md-unset"
                 v-for=" (method, index) in depositMethods" :key="index"
                 @click="selectMethod(method)">
              <PaymentMethod
                  :methodPay="method"
                  :activeMethod=selectedMethod.id
                  ref="cards"
              />
            </div>
          </div>
          <div class="back-arrow-block d-flex d-lg-none mt-1">
            <span @click="backData(selectedMethod)" v-if="isCardAndSbp" class="back-arrow"><i class="fa fa-arrow-left"
                                                                                              aria-hidden="true"></i></span>
          </div>
          <div class="suma-block"
               v-if="(selectedMethod.name !== '' || selectedMethod.module === 'nicepay')">
            <b-form
                id="deposit-form"
                class="my-4 mx-0 deposit-form"
                method="POST"
                :action="$_config.payInUrl"
                @submit="payInFormSubmit"
            >
              <b-row class="mx-0 mt-3">
                <div class="col-12 input-group px-0">
                  <input
                      id="depositAmount"
                      ref="depositAmount"
                      v-model="sum"
                      name="payin_amount"
                      class="form-control main-input"
                      placeholder="Сумма в рублях"
                      type="text"
                      required
                  >
                </div>
              </b-row>
              <div class="alert-text mt-3" v-if="amountAlert">

                <strong>
                  <span> Уважаемый клиент, обратите внимание, что сумма может быть изменена. Пожалуйста, проверьте окончательную сумму на странице оплаты. В случае неоплаты корректной суммы заявка может не быть успешно обработана. </span>
                </strong>

              </div>
              <div class="promo-text" @click="promoCode" v-if="!isPromoCode">
                <span>У меня есть промокод</span>
              </div>
              <div v-if="isPromoCode">
                <b-row class="mx-0 mt-3">
                  <div class="col-12 input-group px-0">
                    <input
                        id="depositPromocode"
                        ref="depositPromocode"
                        class="form-control main-input"
                        placeholder="Депозитный промокод"
                        type="text"
                        name="depositPromocode"
                    >
                  </div>
                </b-row>
                <div class="promo-text" @click="promoCode">
                  <span>Не вводить промокод</span>
                </div>
              </div>

              <b-row v-if="sum" class="mt-4">
                <div class="col-12 input-group ">
                  <label class="col-form-label ">
                    Итого к оплате : {{ sum }} Руб {{ selectedMethod.name ? '- Метод : ' + selectedMethod.name : '' }}
                  </label>
                </div>
              </b-row>

              <b-col cols="12" class="px-0 col-md-12 col-lg-11 mx-0 mx-lg-auto">
                <Alert :message="formResponse"></Alert>
              </b-col>

              <b-row class="mt-3 text-center mx-0 col-12 px-0">
                <div class="col-12 col-lg-6 mx-lg-auto px-0 px-lg-3">
                  <div class="green-btn-bg">
                    <button class="btn red-btn w-100 text-white" type="submit">
                      Пополнить
                    </button>
                  </div>
                </div>
                <div class="form-group row">
                  <input v-model="selectedMethod.id" type="hidden" name="method">
                  <input v-model="selectedMethod.module" type="hidden" name="selected_system">
                </div>
              </b-row>
            </b-form>
          </div>
        </div>
        <div>
          <div v-if="userData && userData.can_get_double_promotion" class="py-4 text-center mx-0 col-12">
            <p>
              <strong class="text-red-gradient">
                <i class="fa fa-thin fa-gift zoom-in-zoom-out"></i> +100% BONUS к первому депозиту <br>
              </strong>
              <br>
              <span class="text-white bonus-text">
                      Сделайте своё первое пополнение и получите <strong class="text-uppercase">удвоение</strong>
                      своего депозита (удвоение будет только при первом пополнении)
                    </span>
            </p>
          </div>
          <div v-if="selectedMethod.name !== '' && userData"
               class="text-center mx-0 py-4 col-12 promo-activation-area">
            <span class="gray-color deposit-hint d-block">Минимальный депозит {{
                selectedMethod.min_amount
              }} Руб.</span>
            <span class="gray-color deposit-hint d-block">Максимальный депозит за раз {{
                selectedMethod.max_amount
              }} Руб.</span>
          </div>
          <div v-if="userData" class="py-4 text-center mx-0 col-12 promo-activation-area">
            <div class="col-12 col-sm-10  col-lg-6 mx-auto px-0">
              <button name="ActivatePromoCode"
                      class="btn btn-red-to-orange w-100"
                      @click="$root.$emit('bv::show::modal','ActivatePromoCode')"
              >
                Пополнение с промо-кода
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="alert alert-primary">
        <div class="col-12 resp-loader loading">
          <i class="fa fa-spinner fa-spin fa-fw"/>
        </div>
      </div>
    </div>
    <ActivatePromoCode></ActivatePromoCode>
  </div>

</template>

<script>
import PaymentMethod from './PaymentMethod.vue'
import ActivatePromoCode from './ActivatePromoCode.vue'
import Alert from '@/components/Alert'

export default {
  name: 'DepositBlock',
  components: {
    PaymentMethod,
    Alert,
    ActivatePromoCode
  },

  data() {
    return {
      isCardAndSbp: false,
      amountAlert:false,
      isDropdownOpen: false,
      isPromoCode: false,
      selectedOption: {
        label: '',
        image: ''
      },
      sum: null,
      selectedMethod: {
        id: null,
        module: '',
        name: '',
        min_amount: null,
        max_amount: null,
        picture: ''
      },
      cardMethod: {
        id: 2,
        name: 'Карта',
        method_type: 'card',
        card_picture: require('@/../public/images/icons/karta.svg')
      },
      sbpMethod: {
        id: 1,
        name: 'СБП',
        method_type: 'sbp',
        card_picture: require('@/../public/images/icons/sbp.svg')
      },
      transferMethod: {
        id: 3,
        name: 'Банковские переводы',
        method_type: 'transfer',
        card_picture: require('@/../public/images/icons/transfer.svg')
      },
      sberPayMethod: {
        id: 4,
        name: 'SberPay',
        method_type: 'sberpay',
        card_picture: require('@/../public/images/icons/transfer.svg')
      },
      selectionChange: null,
      formResponse: null
    }
  },

  computed: {
    userData() {
      return this.$store.getters.userData
    },
    depositMethods() {
      return this.$store.getters.getDepositMethods
    },
    depositSettings() {
      return this.$store.getters.getDepositSettings
    }
  },

  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    promoCode() {
      this.isPromoCode = !this.isPromoCode
    },
    getPictureUrl(url) {
      if (url.card_picture) {
        return url.card_picture;
      } else {
        return url.picture;
      }
    },
    blockMethod(key) {
      if (!this.userData) {
        this.$root.$emit('bv::hide::modal', 'paymentModal')
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Для пополнения баланса нужно авторизоваться')
      }
      this.isCardAndSbp = false;
      this.isDropdownOpen = false;
      this.selectedMethod = key
      this.selectedOption.label = key.name
      this.selectedOption.image = key.picture ?? key.card_picture
    },
    backData(method) {
      this.isCardAndSbp = false;
      this.isDropdownOpen = false;

      if (method.method_type === 'card') {
        this.selectedMethod = this.cardMethod
        this.selectedOption.label = this.cardMethod.name
        this.selectedOption.image = this.cardMethod.picture ?? this.cardMethod.card_picture
      } else if (method.method_type === 'sbp') {
        this.selectedMethod = this.sbpMethod
        this.selectedOption.label = this.sbpMethod.name
        this.selectedOption.image = this.sbpMethod.picture ?? this.sbpMethod.card_picture
      } else if (method.method_type === 'transfer') {
        this.selectedMethod = this.transferMethod
        this.selectedOption.label = this.transferMethod.name
        this.selectedOption.image = this.transferMethod.picture ?? this.transferMethod.card_picture
      } else if (method.method_type === 'sberpay') {
        this.selectedMethod = this.sberPayMethod
        this.selectedOption.label = this.sberPayMethod.name
        this.selectedOption.image = this.sberPayMethod.picture ?? this.sberPayMethod.card_picture
      }
    },
    selectMethod(selected) {
      if (!this.userData) {
        this.$root.$emit('bv::hide::modal', 'paymentModal')
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Для пополнения баланса нужно авторизоваться')
      }
      this.amountAlert = false;
      this.isDropdownOpen = false;
      this.selectedMethod = selected
      this.selectedMethod.module = selected.method_module
      this.selectedMethod.picture = selected.img ?? selected.picture
      this.selectedOption.label = selected.name
      this.selectedOption.image = selected.picture ?? selected.img

      if(selected.method_module === 'adwin'){
        this.amountAlert = true;
      }
      this.$refs.depositAmount.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    payInFormSubmit(e) {
      if (!this.userData) {
        e.preventDefault()
        this.formResponse = {status: 'error', msg: 'Unauthorized'}
        setTimeout(() => {
          this.$router.push({name: 'login'})
        }, 500)
        return
      }
      const payInAmount = parseFloat(this.$refs.depositAmount.value) || 0
      if (!payInAmount > 0) {
        e.preventDefault()
        this.formResponse = {status: 'error', msg: 'Пожалуйста, укажите правильую сумму'}
        return false
      }
      if (!this.selectedMethod.id || !this.selectedMethod.module) {
        e.preventDefault()
        this.formResponse = {status: 'error', msg: 'Пожалуйста выберите метод депозита'}
        return false
      }

      if(parseFloat(this.$refs.depositAmount.value) < this.selectedMethod.min_amount) {
        e.preventDefault()
        this.formResponse = {status: 'error', msg: "Пожалуйста, укажите сумму, превышающую минимальную сумму для выбранного метода депозита."}
        return false
      }

      if(parseFloat(this.$refs.depositAmount.value) > this.selectedMethod.max_amount) {
        e.preventDefault()
        this.formResponse = {status: 'error', msg: "Пожалуйста, укажите сумму, не превышающую максимальную сумму для выбранного метода депозита."}
        return false
      }

      return true
    },
  },

  watch: {
    sum() {
      const payInAmount = parseFloat(this.$refs.depositAmount.value) || 0
      if (payInAmount != this.sum) {
        this.sum = payInAmount
        return this.formResponse = {status: 'error', msg: 'Пожалуйста, укажите правильую сумму'}
      } else {
        return this.formResponse = {}
      }
    }
  },

  mounted() {
    this.$store.dispatch('fetchAvailableDepositMethods')
    this.$store.dispatch('fetchDepositsHistory')
    this.selectedOption.label = this.cardMethod.name
    this.selectedOption.image = this.cardMethod.card_picture
    this.selectedMethod.module = 'nicepay'
  },

}
</script>

<style scoped>
.alert-text {
  font-size: 14px;
  color: #e52a06;
}

.method-block {
  border-right: 2px solid rgb(143, 141, 141);
}
.promo-text {
  margin-top: 25px;
  color: #a7aaad;
  font-size: 15px;
  transition: 0.5s;
  cursor: pointer;
}

.promo-text:hover {
  color: white;
}

.selected-method {
  width: calc(50% - 6px);
}

.deposit-amount-btn,
.col-form-label,
.bonus-text,
.deposit-hint {
  font-size: 12px;
}

.promo-activation-area {
  border-top: 1px solid #333333;
}

#depositAmount,
#depositPromocode {
  background: #1c2028;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  height: 40px;
  padding-left: 35px;
}

@media (max-width: 992px) {
  .back-arrow-block {
    font-size: 20px;
  }

  .back-arrow {
    color: #a7aaad;
  }

  .back-arrow:hover {
    color: white;
  }

  .deposit-amount-btn {
    margin-top: 10px;
  }

  .method-block {
    overflow: unset;
    padding: 0;
  }
  .selected-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
    background-color: #1c2028;
    border: 1px solid #333946;
    border-radius: 5px;
    box-shadow: 1px 3px 3px -2px #20242d;
    color: #aab0bd;
  }
}
</style>
